import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { NotificationType } from "../../../../../../apis/networkdashboard/graphql/graphql";
import { services } from "../../../../../../app/services";
import { AvailabilityExportItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/availability-export/availability-export-item";
import { AvailabilityItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/availability/availability-item";
import { MalfunctionItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/malfunction/malfunction-item";
import { SelfServiceItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/self-service/self-service-item";
import { SendConfigItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/send-config/send-config-item";
import { ServiceDocumentationItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/service-documentation/service-documentation";
import { ToCertItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/to-cert/to-cert-item";
import { ShortcutMenu } from "../../../../../../components/subscription-detail/shortcut-menu/shortcut-menu";
import { ProductType } from "../../../../../../helpers/enums/productType";
import { IpSubscriptionDetails } from "../../../../../../pages/subscription-detail/types";

@Component({
  selector: "ip-shortcut-menu",
  templateUrl: "ip-shortcut-menu.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AvailabilityItem,
    AvailabilityExportItem,
    MalfunctionItem,
    SelfServiceItem,
    SendConfigItem,
    ServiceDocumentationItem,
    ToCertItem,
    ShortcutMenu,
  ],
})
export class IpShortCutMenu {
  readonly subscription = input.required<IpSubscriptionDetails>();
  readonly activities = input.required<NotificationType[]>();
  protected readonly subscriptionId = computed(() => this.subscription().subscriptionId);
  protected readonly dirty = computed(() => this.subscription().dirty);

  protected readonly serviceDocumentationUrl = services[ProductType.IP].docs;
}
